// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"4ec5e5df","223":"eaf36edb","541":"dec73416"}[chunkId] + ".css";
};